<template>
    <div>
        <Lottery ref="lottery" v-bind="lotteryOptions" :lottie-modal-ref="$refs.lottieModal" />
        <DrawResultModal v-model="showDrawResultModal" :draw-result="drawResult" />
        <multiDrawResultModal v-model="showMultiDrawResultModal" :draw-result="multiDrawResult" />
        <multiDrawFailResultModal
            v-model="isMultiDrawFailModalShow"
            :draw-result="multiDrawFailResult"
            @modal-btn-click="failModalBtnClick"
        />
        <LottieModal
            ref="lottieModal"
            v-if="needAnimate"
            v-model="isLotteryModalShow"
            :start-animate-link="startAnimateLink"
            :loop-animate-link="loopAnimateLink"
            :end-animate-link="endAnimateLink"
            :auto-start="false"
        />
    </div>
</template>

<script>
import { use as webapiUse } from '@fegobull/webapi';
import { common, store } from '@futuweb/fego-render';
import {
    EVENT_NAME,
    FAIL_DRAW_COUNT_PLACEHOLDER,
    REMAIN_COUNT_PLACEHOLDER,
    SUCCESS_DRAW_COUNT_PLACEHOLDER
} from '../constants/business';
import { isH5, isLogin } from '../utils';
import DrawResultModal from './DrawResultModal/index.vue';
import Lottery from './Lottery/index.vue';
import LottieModal from './LottieModal/index.vue';
import multiDrawFailResultModal from './multiDrawFailResultModal/index.vue';
import multiDrawResultModal from './multiDrawResultModal/index.vue';
const { variable } = store;

const Toast = window.FEGOEditor ? null : webapiUse.useToast();
const ENV_MAP = {
    TEST: 'test',
    PROD: 'prod'
};

export default {
    name: 'lottery3',
    props: {
        notLoggedText: {
            type: String,
            default: ''
        },
        hasLoggedText: {
            type: String,
            default: ''
        },
        appGroup: {
            type: Array,
            default: () => []
        },
        remainCountName: {
            type: String,
            default: 'commonLotteryRemain'
        },
        currentCountName: {
            type: String,
            default: 'commonLotteryCurrent'
        },
        totalCountName: {
            type: String,
            default: 'commonLotteryTotal'
        },
        // 一键十抽成功弹窗配置
        multiDrawSucTitle: {
            type: String,
            default: ''
        },
        multiDrawSucDesc: {
            type: String,
            default: ''
        },
        multiDrawSucBtnLabel: {
            type: String,
            default: ''
        },
        multiDrawSucBtnUrl: {
            type: String,
            default: ''
        },
        // 一键多抽失败弹窗配置
        multiDrawFailTitle: {
            type: String,
            default: ''
        },
        multiDrawFailDesc: {
            type: String,
            default: ''
        },
        multiDrawFailBtnLabel: {
            type: String,
            default: ''
        },
        multiDrawFailBtnUrl: {
            type: String,
            default: ''
        },
        failCoverUrl: {
            type: String,
            default: ''
        },
        multiDrawCount: {
            type: Number,
            default: 2
        },
        // 抽奖动画配置
        startAnimateLink: {
            type: String,
            default: ''
        },
        loopAnimateLink: {
            type: String,
            default: ''
        },
        endAnimateLink: {
            type: String,
            default: ''
        },
        needAnimate: {
            type: Boolean,
            default: false
        },
        needMultiDraw: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Lottery,
        DrawResultModal,
        multiDrawResultModal,
        multiDrawFailResultModal,
        LottieModal
    },
    data() {
        return {
            isH5: isH5(),
            isLogin,
            drawCountInfo: [],
            showDrawResultModal: false,
            showMultiDrawResultModal: false,
            isMultiDrawFailModalShow: false,
            isLotteryModalShow: false,
            drawResult: {
                title: '',
                cover: '',
                desc: '',
                btnLabel: '',
                btnUrl: ''
            },
            multiDrawResult: {
                title: this.multiDrawSucTitle,
                coverList: [],
                desc: this.multiDrawSucDesc,
                btnLabel: this.multiDrawSucBtnLabel,
                btnUrl: this.multiDrawSucBtnUrl
            },
            multiDrawFailResult: {
                title: this.multiDrawFailTitle,
                coverList: [],
                desc: this.multiDrawFailDesc,
                btnLabel: this.multiDrawFailBtnLabel,
                btnUrl: this.multiDrawFailBtnUrl
            },
            env: ENV_MAP.PROD
        };
    },
    computed: {
        appGroupFiltered() {
            if (this.env === ENV_MAP.TEST) {
                return this.appGroup.map((item) => {
                    return {
                        ...item,
                        appKey: item.appKeyTestEnv,
                        group: item.groupTestEnv,
                        prizeList: item.prizeList.map((prize) => {
                            return {
                                ...prize,
                                prizeKey: prize.prizeKeyTestEnv
                            };
                        })
                    };
                });
            }
            return this.appGroup;
        },
        // 总抽奖次数
        drawCount() {
            let remain = 0;
            let current = 0;
            let total = 0;
            this.drawCountInfo.forEach((item) => {
                remain += item.remain;
                current += item.current;
                total += item.total;
            });
            return {
                current,
                remain,
                total
            };
        },
        // 抽奖配置
        // eslint-disable-next-line max-lines-per-function
        lotteryOptions() {
            const remain = this.drawCount.remain;
            let text = this.notLoggedText;
            if (isLogin) {
                text = this.hasLoggedText.replace(REMAIN_COUNT_PLACEHOLDER, this.drawCount.remain);
            }
            return {
                remain,
                text,
                drawCb: async () => {
                    const res = await this.draw();
                    return res;
                },
                drawSuccessCb: (res) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    const reward = res?.[0] || null;
                    if (!reward?.prizeKey) {
                        throw new Error('request failed');
                    }
                    const app = this.appGroupFiltered.find((item) => item.appKey === reward.appKey);
                    const target = app.prizeList.find((item) => item.prizeKey === reward.prizeKey);
                    if (target) {
                        this.drawResult = {
                            title: target.congratTitle || '',
                            cover: target.congratImgUrl || '',
                            desc: target.congratDesc || '',
                            btnLabel: target.congratBtnLabel || '',
                            btnUrl: target.congratBtnUrl || ''
                        };
                        this.showPrizeModal(target);
                    }
                    this.$nextTick(() => {
                        this.$emit(EVENT_NAME.DRAW_SUCCESS, reward);
                    });
                },
                drawFailCb: (err) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    console.log(err);
                    Toast.error({ message: 'The request failed, please refresh and try again' });
                    this.$emit(EVENT_NAME.DRAW_FAIL);
                },
                noRemainCb: () => {
                    this.$emit(EVENT_NAME.NO_REMAIN);
                },
                noLoginCb: () => {
                    this.$emit(EVENT_NAME.NO_LOGIN);
                },
                // 一键十抽回调
                multiDrawCb: async () => {
                    const res = await this.multiDraw();
                    return res;
                },
                multiDrawSuccessCb: (res) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    // 获取抽中奖品对应的配置
                    const coverList = this.getCoverList(res);
                    this.multiDrawResult = {
                        title: this.multiDrawSucTitle,
                        desc: this.multiDrawSucDesc,
                        btnLabel: this.multiDrawSucBtnLabel,
                        btnUrl: this.multiDrawSucBtnUrl,
                        coverList
                    };
                    this.showMultiPrizeModal();
                    this.$nextTick(() => {
                        this.$emit(EVENT_NAME.DRAW_SUCCESS, res);
                    });
                },
                multiDrawFailCb: (res) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    if (!res) {
                        this.$emit(EVENT_NAME.DRAW_FAIL);
                        return;
                    }

                    const failCount = res.filter((item) => item.prizeId === null).length;
                    const totalCount = res.length;
                    if (failCount === totalCount) {
                        this.$emit(EVENT_NAME.DRAW_FAIL);
                        return;
                    }

                    // 对数组进行排序，将失败的奖品（prizeId 为 null）放到最后
                    const sortedRes = [...res].sort((itemA, itemB) => {
                        return (itemA.prizeId === null) - (itemB.prizeId === null);
                    });
                    const coverList = this.getCoverList(sortedRes);

                    // 处理占位符替换，数字补齐为两位数并用 HTML 标签包围
                    let desc = this.multiDrawFailDesc;
                    desc = desc.replace(FAIL_DRAW_COUNT_PLACEHOLDER, this.generateHighlightNumber(failCount));
                    desc = desc.replace(
                        SUCCESS_DRAW_COUNT_PLACEHOLDER,
                        this.generateHighlightNumber(totalCount - failCount)
                    );

                    this.multiDrawFailResult = {
                        title: this.multiDrawFailTitle,
                        desc,
                        btnLabel: this.multiDrawFailBtnLabel,
                        btnUrl: this.multiDrawFailBtnUrl,
                        coverList
                    };
                    this.showMultiFailPrizeModal();
                }
            };
        }
    },
    watch: {
        drawCount: {
            handler(newValue) {
                // 透出fego变量
                const currentName = this.currentCountName;
                const remainName = this.remainCountName;
                const totalName = this.totalCountName;
                variable.data[currentName] = newValue.current;
                variable.data[remainName] = newValue.remain;
                variable.data[totalName] = newValue.total;
            },
            deep: true // 开启深度监听
        }
    },
    mounted() {
        if (window.FEGORender && isLogin) {
            this.getDrawCount();
        }
    },
    methods: {
        getDrawConfigs() {
            return this.appGroup.map((item) => {
                return {
                    app_key_encode: item.appKeyEncode,
                    group_encode: item.groupEncode,
                    app_key_encode_test_env: item.appKeyEncodeTestEnv,
                    group_encode_test_env: item.groupEncodeTestEnv
                };
            });
        },
        async getDrawCount() {
            const draw_configs_encode = this.getDrawConfigs();
            if (!isLogin || !draw_configs_encode.length) {
                return;
            }

            const { request } = common;
            const commonApiLottery = request.bindCommonApi('lottery3');
            const loading = Toast.loading({ message: 'Loading...', duration: 0 });
            try {
                const { env, drawCountInfo } = await commonApiLottery.post(
                    'drawCountInfo',
                    {
                        draw_configs_encode
                    },
                    {
                        group: null // 不需要限制请求频次
                    }
                );
                this.drawCountInfo = drawCountInfo;
                this.env = env || ENV_MAP.PROD;
                loading.close();
            } catch (error) {
                loading.close();
                throw error;
            }
        },
        async draw() {
            const draw_configs_encode = this.getDrawConfigs();
            const { request } = common;
            const commonApiLottery = request.bindCommonApi('lottery3');

            let loading = null;
            if (!this.needAnimate) {
                loading = Toast.loading({ message: 'Loading...', duration: 0 });
            }

            try {
                const res = await commonApiLottery.post('draw', {
                    draw_configs_encode,
                    count: 1
                });
                if (!this.needAnimate) {
                    loading.close();
                }
                return res;
            } catch (error) {
                if (!this.needAnimate) {
                    loading.close();
                }
                throw error;
            }
        },
        /**
         * 一键多抽
         */
        async multiDraw() {
            const draw_configs_encode = this.getDrawConfigs();
            const { request } = common;
            const commonApiLottery = request.bindCommonApi('lottery3');

            let loading = null;
            if (!this.needAnimate) {
                loading = Toast.loading({ message: 'Loading...', duration: 0 });
            }
            try {
                const availableCount = Math.min(this.multiDrawCount, this.drawCount.remain);
                const list = await commonApiLottery.post('draw', {
                    draw_configs_encode,
                    count: availableCount
                });
                if (!this.needAnimate) {
                    loading.close();
                }

                return list;
            } catch (error) {
                if (!this.needAnimate) {
                    loading.close();
                }
                throw error;
            }
        },
        /**
         * 生成带高亮标签的数字字符串
         */
        generateHighlightNumber(number) {
            return `<span class="highlight">${number}</span>`;
        },
        getCoverList(prizeResArr) {
            const coverList = prizeResArr.map((item) => {
                const app = this.appGroupFiltered.find((appItem) => appItem.appKey === item.appKey);
                const target = app?.prizeList.find((prizeItem) => prizeItem.prizeKey === item.prizeKey) || {};
                return target.congratImgUrl || this.failCoverUrl;
            });
            return coverList;
        },
        showPrizeModal(target) {
            if (target.useCustomPrizeModal) {
                if (target.fegoPrizeModel) {
                    // 使用fego自定义获奖弹窗
                    this.openDialog(target.fegoPrizeModel);
                }
                // 未配置fego自定义获奖弹窗，则不弹出任何弹窗
            } else {
                // 默认获奖弹窗
                this.showDrawResultModal = true;
            }
        },
        showMultiPrizeModal() {
            this.showMultiDrawResultModal = true;
        },
        showMultiFailPrizeModal() {
            this.isMultiDrawFailModalShow = true;
        },
        /**
         * 打开fego弹窗
         */
        openDialog(tplId) {
            const {
                behavior: { runBehaviour }
            } = common;
            runBehaviour(this, {
                type: 'operateComponent',
                value: '',
                tplId,
                methodName: 'open'
            });
        },

        /**
         * 抽奖(供交互配置使用)
         */
        async lotteryDraw() {
            if (this.drawCount.remain <= 0) {
                await this.getDrawCount();
            }

            this.$refs.lottery.draw();
        },
        /**
         * 一键多抽(供交互配置使用)
         */
        async lotteryMultiDraw() {
            if (this.drawCount.remain <= 0) {
                await this.getDrawCount();
            }

            if (this.needMultiDraw) {
                this.$refs.lottery.multiDraw();
            } else {
                this.$refs.lottery.draw();
            }
        },
        /**
         * 失败弹窗按钮点击
         */
        failModalBtnClick() {
            this.$emit(EVENT_NAME.FAIL_MODAL_BTN_CLICK);
        }
    }
};
</script>

<style lang="less" scoped></style>
